import { useCallback } from 'react';
import { equals } from 'ramda';
import { useTranslations } from 'js/hooks/i18n';
import { useShowNotification } from 'js/components/common/Notifications';
import useErrorHandler from './useErrorHandler';
import { usePortletConfig } from 'js/components/system/Portlet';

export const isPristineDefault = (data, form) => {
    const { initialValues } = form.getState();
    return equals(data, initialValues);
};

export const useDefaultParams = () => ({ type: usePortletConfig().portletType });

export const useOnSubmit = ({
    fetchLimits,
    saveLimits,
    isPristine = isPristineDefault,
    useParams = useDefaultParams
}) => {
    const t = useTranslations('playtech.mobile.system.limits.');
    const showNotification = useShowNotification({ iconType: 'info' });
    const handleError = useErrorHandler();
    const params = useParams();

    return useCallback(async (data, form) => {
        if (isPristine(data, form)) {
            return t('noChanges');
        }

        try {
            await saveLimits(data, form);
            showNotification({ message: t('saved') });
        } catch (e) {
            return handleError(e, 'save');
        }

        try {
            fetchLimits(params, { showLoader: false });
        } catch (e) {
            return handleError(e, 'fetch');
        }
    }, [isPristine, t, saveLimits, showNotification, handleError, fetchLimits, params]);
};
